<app-header></app-header>
<div class="row finzy-main-row">
  <div class="col-xs-12 col-md-10 ml-md-4">
    <ng-container *ngIf="!isFINXLender">
      <div id="final-certificate-container">

        <div class="col-xs-12 col-md-12">
          <p class="finzy-prov-1 col-md-12 pl-0">Final Certificates</p>
          <p>
            Your final interest certificate for the previous financial year will
            be made available to you by the 30th of April. You can download the
            certificates for earlier years below.
          </p>
        </div>

        <div class="col-md-12">
          <ng-container *ngIf="!shouldShowFinalCertificatesLoader">
            <mat-table class="mat-elevation-z2" [dataSource]="flexFinalInterestCertificateDataSource"  *ngIf="shouldShowFinalCertificatesTable"
              matSort>
              <ng-container matColumnDef="financialYear">
                <mat-header-cell *matHeaderCellDef>Financial Year</mat-header-cell>
                <mat-cell *matCellDef="let interestCertificate">
                  {{ interestCertificate.financialYear }}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="downloadUrl">
                <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
                <mat-cell *matCellDef="let interestCertificate">
                  <a *ngIf="interestCertificate.financialYear"
                    (click)="downloadInterestCertificateFile(interestCertificate.financialYear)">Download</a>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="downloadStatementOfReturn">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let interestCertificate">
                  <a *ngIf="interestCertificate.financialYear" (click)="
                      downloadStatementOfReturnsFile(interestCertificate.financialYear)">Statement Of Returns</a>
                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="finalInterestCertificateColumnsToBeDisplayed"></mat-header-row>
              <mat-row *matRowDef="
                    let row;
                    columns: finalInterestCertificateColumnsToBeDisplayed
                  "></mat-row>
            </mat-table>
            <div *ngIf="!shouldShowFinalCertificatesTable" id="no-final-certificates-available-section"
              class="text-center">
              <p>
                There are no final certificates available for you at the moment.
              </p>
            </div>
          </ng-container>
          <mat-spinner [diameter]="35" class="mat-spinner col-xs-6 col-xs-offset-6"
            *ngIf="shouldShowFinalCertificatesLoader"></mat-spinner>
        </div>

        <div class="col-sm-12">
          <p class="finzy-p6">If you need assistance you can find help <a [routerLink]="['/faq']">here</a>. You could
            even call us on <a class="phone-number" href="tel:9341300300" rel="nofollow">9341 300 300</a>. We
            are always happy to help!</p>
        </div>

      </div>
    </ng-container>

    <ng-container *ngIf="isFINXLender">
      <div class="col-sm-12">
        <div class="row finzy-prov-div">
          <p class="finzy-prov-2">To get your interest certificate please write to <a
              href="mailto:support@finzy.com" target="_blank">support@finzy.com</a></p>
        </div>
      </div>
    </ng-container>
  </div>
</div>